import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import { useTranslationApp } from "../../lib/i18next";
import {
  getRoleCapabilityTooltipLabels,
  ROLE_TITLE_I18N_KEYS,
} from "../../utils/roleCapabilities";

const RoleCapabilitiesTooltipContent = ({ labels }) => (
  <Box component="ul" sx={{ m: 0, mt: 0.5, pl: 2, mb: 0 }}>
    {labels.map((label) => (
      <Typography
        key={label}
        component="li"
        variant="body2"
        color="inherit"
        sx={{ mb: 0.25 }}
      >
        {label}
      </Typography>
    ))}
  </Box>
);

const RoleCapabilitiesTooltip = ({ role, stopPropagation = true }) => {
  const { t } = useTranslationApp();
  const labels = getRoleCapabilityTooltipLabels({ role, t });
  const titleKey = ROLE_TITLE_I18N_KEYS[role];

  if (!titleKey) {
    return null;
  }

  const onStopPropagation = (event) => {
    if (stopPropagation) {
      event.stopPropagation();
    }
  };

  return (
    <Tooltip
      arrow
      placement="left"
      describeChild
      title={
        <Box>
          <Typography variant="body2" sx={{ fontWeight: 600 }}>
            {t(titleKey)}
          </Typography>
          {labels.length > 0 ? (
            <RoleCapabilitiesTooltipContent labels={labels} />
          ) : null}
        </Box>
      }
      componentsProps={{
        popper: {
          sx: { zIndex: 10001 },
        },
      }}
    >
      <Box
        className="tooltip-modal"
        component="span"
        onClick={onStopPropagation}
        onMouseDown={onStopPropagation}
        sx={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: 20,
          height: 20,
          borderRadius: "50%",
          backgroundColor: "#000",
          color: "#fff",
          fontSize: 12,
          fontWeight: 700,
          lineHeight: 1,
          flexShrink: 0,
          cursor: "help",
          userSelect: "none",
        }}
      >
        ?
      </Box>
    </Tooltip>
  );
};

export default RoleCapabilitiesTooltip;
